/**
 * Explicit SVG URL imports for country codes used by text translation.
 *
 * Using the Vite ?url suffix emits each SVG as a separate hashed asset file.
 * The browser only fetches an SVG when an <img> element with that src is
 * actually rendered in the DOM — so flags inside a closed dropdown cost zero
 * network requests.  The full flag-icons CSS is no longer loaded globally.
 */
import saSvg from 'flag-icons/flags/4x3/sa.svg?url'
import czSvg from 'flag-icons/flags/4x3/cz.svg?url'
import dkSvg from 'flag-icons/flags/4x3/dk.svg?url'
import deSvg from 'flag-icons/flags/4x3/de.svg?url'
import gbSvg from 'flag-icons/flags/4x3/gb.svg?url'
import esSvg from 'flag-icons/flags/4x3/es.svg?url'
import eeSvg from 'flag-icons/flags/4x3/ee.svg?url'
import frSvg from 'flag-icons/flags/4x3/fr.svg?url'
import bgSvg from 'flag-icons/flags/4x3/bg.svg?url'
import ilSvg from 'flag-icons/flags/4x3/il.svg?url'
import inSvg from 'flag-icons/flags/4x3/in.svg?url'
import huSvg from 'flag-icons/flags/4x3/hu.svg?url'
import itSvg from 'flag-icons/flags/4x3/it.svg?url'
import jpSvg from 'flag-icons/flags/4x3/jp.svg?url'
import krSvg from 'flag-icons/flags/4x3/kr.svg?url'
import lvSvg from 'flag-icons/flags/4x3/lv.svg?url'
import nlSvg from 'flag-icons/flags/4x3/nl.svg?url'
import plSvg from 'flag-icons/flags/4x3/pl.svg?url'
import ptSvg from 'flag-icons/flags/4x3/pt.svg?url'
import roSvg from 'flag-icons/flags/4x3/ro.svg?url'
import ruSvg from 'flag-icons/flags/4x3/ru.svg?url'
import skSvg from 'flag-icons/flags/4x3/sk.svg?url'
import trSvg from 'flag-icons/flags/4x3/tr.svg?url'
import uaSvg from 'flag-icons/flags/4x3/ua.svg?url'
import cnSvg from 'flag-icons/flags/4x3/cn.svg?url'
import seSvg from 'flag-icons/flags/4x3/se.svg?url'
import siSvg from 'flag-icons/flags/4x3/si.svg?url'
import rsSvg from 'flag-icons/flags/4x3/rs.svg?url'
import noSvg from 'flag-icons/flags/4x3/no.svg?url'
import grSvg from 'flag-icons/flags/4x3/gr.svg?url'
import fiSvg from 'flag-icons/flags/4x3/fi.svg?url'
import esCtSvg from 'flag-icons/flags/4x3/es-ct.svg?url'
import hrSvg from 'flag-icons/flags/4x3/hr.svg?url'
import ltSvg from 'flag-icons/flags/4x3/lt.svg?url'
import ieSvg from 'flag-icons/flags/4x3/ie.svg?url'
import usSvg from 'flag-icons/flags/4x3/us.svg?url'
import brSvg from 'flag-icons/flags/4x3/br.svg?url'
import twSvg from 'flag-icons/flags/4x3/tw.svg?url'

const FLAG_SVG_MAP = {
  sa: saSvg,
  cz: czSvg,
  dk: dkSvg,
  de: deSvg,
  gb: gbSvg,
  es: esSvg,
  ee: eeSvg,
  fr: frSvg,
  bg: bgSvg,
  il: ilSvg,
  in: inSvg,
  hu: huSvg,
  it: itSvg,
  jp: jpSvg,
  kr: krSvg,
  lv: lvSvg,
  nl: nlSvg,
  pl: plSvg,
  pt: ptSvg,
  ro: roSvg,
  ru: ruSvg,
  sk: skSvg,
  tr: trSvg,
  ua: uaSvg,
  cn: cnSvg,
  se: seSvg,
  si: siSvg,
  rs: rsSvg,
  no: noSvg,
  gr: grSvg,
  fi: fiSvg,
  'es-ct': esCtSvg,
  hr: hrSvg,
  lt: ltSvg,
  ie: ieSvg,
  us: usSvg,
  br: brSvg,
  tw: twSvg,
}

/**
 * Returns the asset URL for a given flag country code (e.g. "gb", "de").
 * Returns an empty string if the code is unknown, so callers can safely
 * omit the <img> when there is no matching flag.
 *
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code from relation.js
 * @returns {string}
 */
export function getFlagSvgUrl(countryCode) {
  if (!countryCode) return ''
  return FLAG_SVG_MAP[countryCode] ?? ''
}
